import React, { FC, useEffect, useState } from "react";
import { Layout, Menu, Row, Col } from "antd";
import { NavLink } from "react-router-dom";

import InstrumentsMarquee from "./InstrumentsMarquee";
import long from "../../../../assets/media/images/long.png";
import { APIRoutes } from "../../../../http";
import { UIRoutes } from "../../../../router";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import { ICryptoIndex } from "../../../../models/cryptoindex.model";
import RequestsService from "../../../../services/requests.service";

const AppHeader: FC = () => {
  const indexId = useTypedSelector(({ ci }) => ci.indexId);

  const [indices, setIndices] = useState([] as ICryptoIndex[]);

  useEffect(() => {
    RequestsService.getMethod(`${APIRoutes.CRYPTO_INDEX}`)
      .then((response: any) => {
        setIndices(response.data?.result);
      })
      .catch((_) => { });
  }, []);

  return (
    <div className="dark-theme">
      <InstrumentsMarquee />
      <Layout.Header>
        <Row>
          <Col span={6}>
            <a href="/">
              <div className="logo">
                <img src={long} alt="logo" />
              </div>
            </a>
          </Col>
          <Col span={18}>
            <Menu theme="dark" mode="horizontal" selectable={false}>
              {indices?.map(f => {
                return (
                  <Menu.Item key={f.id}>
                    <NavLink
                      className={(navData) =>
                        navData.isActive && indexId === f.id ? "active" : ""
                      }
                      to={`/indices/${f.ticker}/${f.id}`}
                    >
                      {f.ticker}
                    </NavLink>
                  </Menu.Item>
                );
              })}

              <Menu.Item key="3">
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to={`/${UIRoutes.CRYPTO_MARKETS} `}
                >
                  Crypto Markets
                </NavLink>
              </Menu.Item>

              <Menu.Item key="4">
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to={`/${UIRoutes.EDUCATION} `}
                >
                  Education
                </NavLink>
              </Menu.Item>
              <Menu.Item key="5">
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to={`/${UIRoutes.CRYPTO_NEWS} `}
                >
                  Crypto News
                </NavLink>
              </Menu.Item>
              <Menu.Item key="6">
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to={`/${UIRoutes.BLOG} `}
                >
                  Blog
                </NavLink>
              </Menu.Item>
            </Menu>
          </Col>
        </Row>
      </Layout.Header>
    </div>
  );
};
export default AppHeader;
